import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M1.5 9.824c0 4.857 3.959 8.816 8.824 8.816a8.725 8.725 0 0 0 5.232-1.735l5.747 5.755c.218.227.523.34.837.34.688 0 1.15-.523 1.15-1.177 0-.323-.113-.602-.322-.82l-5.72-5.746a8.711 8.711 0 0 0 1.9-5.433C19.149 4.96 15.19 1 10.325 1 5.46 1 1.5 4.959 1.5 9.824Zm1.63 0a7.2 7.2 0 0 1 7.194-7.193c3.968 0 7.185 3.226 7.185 7.193 0 3.96-3.217 7.185-7.185 7.185-3.967 0-7.193-3.226-7.193-7.185Z"
  })
});
export default SearchIcon;